import { render, staticRenderFns } from "./Private.vue?vue&type=template&id=25950ddb&scoped=true&"
import script from "./Private.vue?vue&type=script&lang=js&"
export * from "./Private.vue?vue&type=script&lang=js&"
import style0 from "./Private.vue?vue&type=style&index=0&id=25950ddb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25950ddb",
  null
  
)

export default component.exports